import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { Icon } from 'src/components/icon-generator';
import { IconType } from 'src/components/icon-generator/dto';
import Styles from './fmh-back-to-top-button.module.scss';

const FMHBackToTopButton = () => {
    const buttonRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleShowButton = () => {
            if (!buttonRef.current) {
                return;
            }
            if (window.scrollY > 300) {
                buttonRef.current.classList.replace(Styles.hide, Styles.show);
            } else {
                buttonRef.current.classList.replace(Styles.show, Styles.hide);
            }
        };
        document.addEventListener('scroll', handleShowButton);

        return () => document.removeEventListener('scroll', handleShowButton);
    }, []);

    const handleOnclick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={classNames(Styles.backToTopButton, Styles.hide)} onClick={handleOnclick} ref={buttonRef}>
            <Icon icon={IconType.ChevronUp} />
        </div>
    );
};

export default FMHBackToTopButton;
